(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newbundlebuilderpage"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';

    var MIN = +root.dataset.min || 5;
    var STEP = Math.max(1, +root.dataset.step || 1); // units added per click
    var U1 = root.dataset.unit1 || 'roll';
    var UN = root.dataset.unitn || 'rolls';
    var TIERS = JSON.parse(root.dataset.tiers)
      .filter(function (t) { return t.n > 0; })
      .sort(function (a, b) { return a.n - b.n; });
    var MAX = TIERS.length ? TIERS[TIERS.length - 1].n : MIN;

    // A box can only be checked out at one of the tier sizes (e.g. 5, 10 or 15),
    // and it can never grow past the largest tier.
    var SIZES = TIERS.map(function (t) { return t.n; });
    var SIZES_TXT = SIZES.length > 1
      ? SIZES.slice(0, -1).join(', ') + ' or ' + SIZES[SIZES.length - 1]
      : String(SIZES[0] || MIN);
    function validSize(n) { return SIZES.length ? SIZES.indexOf(n) > -1 : n >= MIN; }

    // Uses the same format as the rest of the store (Settings > Store details > Currency display)
    var MF = root.dataset.moneyFormat || ('{' + '{amount}' + '}');
    var money = function (cents) {
      var v = cents / 100;
      return MF.replace(/\{\s*\{\s*(amount[a-z_]*)\s*\}\s*\}/, function (_, type) {
        var decimals = type.indexOf('no_decimals') > -1 ? 0 : 2;
        var comma = type.indexOf('comma') > -1;
        var parts = v.toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, comma ? '.' : ',');
        return parts.join(comma ? ',' : '.');
      });
    };
    var esc = function (s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var unit = function (n) { return n === 1 ? U1 : UN; };

    var items = {};     // variantId -> {id,pid,name,spec,img,price,qty,hex,style}
    var open = false;
    var busy = false;
    var filt = { q: '', cat: 'all', fam: 'all', stock: !!$('.bb-stock').checked, expanded: false };

    /* ---------- colour families (derived from each product's hex) ---------- */
    var FAMS = [
      ['white', '#f3f0ff'], ['black', '#17151f'], ['blue', '#2d7bff'], ['teal', '#25d3b0'],
      ['green', '#2ecf6b'], ['yellow', '#ffc933'], ['pink', '#ff6fa8'], ['purple', '#8b5cff'],
      ['red', '#ff3b3b'], ['orange', '#ff8a2b'], ['grey', '#9a9ab0']
    ];
    function family(hex) {
      var h = (hex || '').replace('#', '');
      if (h.length === 3) h = h.replace(/(.)/g, '$1$1');
      if (!/^[0-9a-f]{6}$/i.test(h)) return '';
      var r = parseInt(h.slice(0, 2), 16) / 255, g = parseInt(h.slice(2, 4), 16) / 255, b = parseInt(h.slice(4, 6), 16) / 255;
      var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, d = mx - mn, s = 0, hu = 0;
      if (d) {
        s = d / (1 - Math.abs(2 * l - 1));
        if (mx === r) hu = ((g - b) / d) % 6; else if (mx === g) hu = (b - r) / d + 2; else hu = (r - g) / d + 4;
        hu = (hu * 60 + 360) % 360;
      }
      if (s < 0.14) return l > 0.82 ? 'white' : (l < 0.16 ? 'black' : 'grey');
      if (l < 0.06) return 'black';
      if (l > 0.93) return 'white';
      if (hu < 15 || hu >= 345) return 'red';
      if (hu < 45) return 'orange';
      if (hu < 70) return 'yellow';
      if (hu < 165) return 'green';
      if (hu < 195) return 'teal';
      if (hu < 255) return 'blue';
      if (hu < 290) return 'purple';
      return 'pink';
    }

    var cards = $$('.bb-card');
    cards.forEach(function (c) { c.dataset.fam = family(c.dataset.hex); });

    /* ---------- build filter chips + swatches ---------- */
    var catsPresent = ['PLA', 'Silk', 'Matte'].filter(function (k) {
      return cards.some(function (c) { return c.dataset.cat === k; });
    });
    function drawCats() {
      $('.bb-cats').innerHTML = ['all'].concat(catsPresent).map(function (k) {
        return '<button type="button" class="bb-chip" data-cat="' + k + '" aria-pressed="' + (filt.cat === k) + '">' + (k === 'all' ? 'All' : k) + '</button>';
      }).join('');
    }
    var famsPresent = FAMS.filter(function (f) {
      return cards.some(function (c) { return c.dataset.fam === f[0]; });
    });
    function drawSwatches() {
      var vis = filt.expanded ? famsPresent : famsPresent.slice(0, 7);
      $('.bb-sw').innerHTML = vis.map(function (f) {
        return '<button type="button" class="bb-dot" data-fam="' + f[0] + '" style="background:' + f[1] + '" aria-label="' + f[0] + '" aria-pressed="' + (filt.fam === f[0]) + '"></button>';
      }).join('') + (famsPresent.length > 7
        ? '<button type="button" class="bb-more" aria-label="More colours" aria-expanded="' + filt.expanded + '"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg></button>'
        : '');
    }
    drawCats();
    drawSwatches();

    function applyFilters() {
      var q = filt.q.trim().toLowerCase(), shown = 0;
      cards.forEach(function (c) {
        var ok = (!filt.stock || c.dataset.avail === 'true') &&
          (filt.cat === 'all' || c.dataset.cat === filt.cat) &&
          (filt.fam === 'all' || c.dataset.fam === filt.fam) &&
          (!q || c.dataset.full.toLowerCase().indexOf(q) > -1 || c.dataset.hex.toLowerCase().indexOf(q) > -1);
        c.hidden = !ok;
        if (ok) shown++;
      });
      $('.bb-none').hidden = shown > 0;
    }

    /* ---------- maths ---------- */
    function count() { return Object.keys(items).reduce(function (a, k) { return a + items[k].qty; }, 0); }
    function tierFor(n) { var t = null; TIERS.forEach(function (x) { if (n >= x.n) t = x; }); return t; }
    function nextTier(n) { return TIERS.filter(function (x) { return x.n > n; })[0]; }

    function toast(text, err) {
      var el = $('.bb-toast');
      el.textContent = text;
      el.className = 'bb-toast show' + (err ? ' err' : '');
      setTimeout(function () { el.classList.remove('show'); }, 2600);
    }

    // true (and shows a message) when adding d more would go past the largest box
    function overCap(d) {
      if (count() + d <= MAX) return false;
      toast('A box holds up to ' + MAX + ' ' + UN + '. Add this box to your cart, then build another.', true);
      return true;
    }

    /* ---------- cards state ---------- */
    function syncCards() {
      var full = count() + STEP > MAX;
      cards.forEach(function (c) {
        var id = c.querySelector('.bb-var').value, it = items[id], q = it ? it.qty : 0, total = 0;
        Object.keys(items).forEach(function (k) { if (items[k].pid === c.dataset.pid) total += items[k].qty; });
        var add = c.querySelector('.bb-add'), avail = c.dataset.avail === 'true';
        add.hidden = q > 0;
        add.disabled = !avail || full;
        if (avail) add.textContent = full ? 'Box is full' : 'Add to box';
        c.querySelector('.bb-cp').disabled = full;
        c.querySelector('.bb-ctl').hidden = !q;
        c.querySelector('.bb-q').textContent = q;
        c.querySelector('.bb-check').hidden = !total;
        c.classList.toggle('in', total > 0);
      });
    }

    /* ---------- dock ---------- */
    var CHEV = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M6 15l6-6 6 6"/></svg>';
    var CHECK = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    var LOCK = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 018 0v3"/></svg>';
    var TRASH = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';
    var ARR_L = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
    var ARR_R = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';
    var SPOOL = '<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="2.6"/><path d="M12 3v6.4M4.2 16.5l5.5-3.2M19.8 16.5l-5.5-3.2"/></svg>';

    // animation state
    var pill = null, pillT = null, evt = null, evtT = null, fresh = null, freshNew = false;
    var lastPct = 0, lastDisc = 0, lastTotal = 0, lastT = null;
    var MOB = window.matchMedia ? matchMedia('(max-width: 900px)') : { matches: false };
    // tiers are spread across the rail (about 9% in from each end), so the bar uses its full length
    function tickPos(i) { return TIERS.length > 1 ? 9 + i * 82 / (TIERS.length - 1) : 50; }
    function railPos(n) {
      n = Math.min(n, MAX);
      if (!TIERS.length) return n / MAX * 100;
      var prevN = 0, prevP = 0;
      for (var i = 0; i < TIERS.length; i++) {
        var p = tickPos(i);
        if (n <= TIERS[i].n) return prevP + (TIERS[i].n === prevN ? 0 : (n - prevN) / (TIERS[i].n - prevN) * (p - prevP));
        prevN = TIERS[i].n; prevP = p;
      }
      return prevP;
    }
    // keep the dock above the theme's fixed mobile toolbar
    function setToolbarOffset() {
      var tb = document.querySelector('toolbar-mobile, .toolbar-mobile');
      var h = tb && getComputedStyle(tb).display !== 'none' ? tb.offsetHeight : 0;
      root.style.setProperty('--bb-tb', (h || 0) + 'px');
    }
    setToolbarOffset();
    window.addEventListener('resize', setToolbarOffset);
    window.addEventListener('load', setToolbarOffset);
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

    function bump(d) {
      if (!d) return;
      pill = { t: (d > 0 ? '+' : '−') + Math.abs(d) + ' ' + unit(Math.abs(d)), up: d > 0 };
      clearTimeout(pillT);
      pillT = setTimeout(function () { pill = null; var el = $('.bb-pill'); if (el) el.remove(); }, 1500);
    }
    function setEvt(e) {
      evt = e;
      clearTimeout(evtT);
      evtT = setTimeout(function () { evt = null; renderDock(); }, 3200);
    }
    function tween(el, from, to, fmt) {
      if (reduce || from === to) { el.textContent = fmt(to); return; }
      var t0 = performance.now(), D = 550;
      el.textContent = fmt(from);
      (function f(now) {
        var p = Math.min(1, (now - t0) / D), e = 1 - Math.pow(1 - p, 3);
        el.textContent = fmt(from + (to - from) * e);
        if (p < 1) requestAnimationFrame(f);
      })(t0);
    }

    function railHTML(n, pct, bubble, compact) {
      var onTier = TIERS.some(function (x) { return x.n === n; });
      return '<div class="bb-rail"><div class="bb-track"><div class="bb-fill" data-to="' + pct + '" style="width:' + lastPct + '%"></div></div>' +
        (!compact && n > 0 ? '<span class="bb-knob" data-to="' + pct + '" style="left:' + lastPct + '%"></span>' : '') +
        (!compact && n > 0 && !onTier ? '<span class="bb-pos" data-to="' + pct + '" style="left:' + lastPct + '%">' + n + ' / ' + MAX + '</span>' : '') +
        TIERS.map(function (x, i) {
          var on = n >= x.n, pop = evt && evt.type === 'up' && evt.n === x.n;
          var icon = on ? CHECK : (compact ? '' : LOCK);
          var label = '<span class="n">' + x.n + ' <em>' + unit(x.n) + '</em></span><span class="sl">' + (compact ? ' · ' : ' / ') + '</span><b>' + x.off + '%' + (compact ? '' : '<span class="off"> OFF</span>') + '</b>';
          return '<div class="bb-tick' + (on ? ' on' : '') + (pop ? ' pop' : '') + '" style="left:' + tickPos(i) + '%"><i>' + icon + '</i><span>' + label + '</span></div>';
        }).join('') + '</div>' + bubble;
    }

    function updArrows() {
      var c = $('.bb-items'); if (!c) return;
      var l = $('.bb-arr.l'), r = $('.bb-arr.r');
      if (l) l.hidden = c.scrollLeft < 4;
      if (r) r.hidden = c.scrollLeft + c.clientWidth >= c.scrollWidth - 4;
    }
    root.addEventListener('scroll', function (e) {
      if (e.target.classList && e.target.classList.contains('bb-items')) updArrows();
    }, true);
    window.addEventListener('resize', updArrows);

    function renderDock() {
      var n = count(), t = tierFor(n), nx = nextTier(n), first = TIERS[0];
      var ok = validSize(n);

      // milestone events (tier crossed up / dropped down)
      var tN = t ? t.n : 0, pN = lastT ? lastT.n : 0;
      if (tN > pN) setEvt({ type: 'up', n: t.n, off: t.off });
      else if (tN < pN && n > 0) setEvt({ type: 'down', off: t ? t.off : 0, prevOff: lastT.off, need: lastT.n - n });
      else if (n === 0 && evt) { evt = null; clearTimeout(evtT); }
      lastT = t;

      var keys = Object.keys(items);
      var sub = 0;
      keys.forEach(function (k) { sub += items[k].price * items[k].qty; });
      var off = n >= MIN && t ? t.off : 0;
      var disc = Math.round(sub * off / 100);
      var total = sub - disc;
      var pct = railPos(n);

      var msg;
      if (n < MIN) msg = 'Add ' + (MIN - n) + ' more ' + unit(MIN - n) + ' to unlock ' + (first ? first.off : 0) + '% off';
      else if (!ok && nx) msg = 'Boxes come in ' + SIZES_TXT + ' ' + UN + ' · add ' + (nx.n - n) + ' more ' + unit(nx.n - n) + ' to complete your box of ' + nx.n;
      else if (nx) msg = (nx.n - n === 1 ? 'Just 1 more ' + U1 : 'Add ' + (nx.n - n) + ' more ' + unit(nx.n - n)) + ' to unlock ' + nx.off + '% off';
      else msg = 'Top tier unlocked · ' + off + '% off';

      var bubble;
      if (evt && evt.type === 'up') {
        bubble = '<div class="bb-bub up" role="status"><span class="ic">&#127881;</span><div><b>' + evt.off + '% OFF UNLOCKED!</b><small>Your whole box now saves ' + evt.off + '%.</small></div></div>';
      } else if (evt && evt.type === 'down') {
        bubble = '<div class="bb-bub" role="status"><div><b>' + n + ' ' + unit(n) + (evt.off ? ' · ' + evt.off + '% off applied' : ' in your box') + '</b><small>Add ' + evt.need + ' ' + unit(evt.need) + ' to unlock ' + evt.prevOff + '% again.</small></div></div>';
      } else {
        bubble = '<div class="bb-bub plain" role="status">' + esc(msg) + '</div>';
      }

      var pillHTML = pill ? '<span class="bb-pill ' + (pill.up ? 'up' : 'dn') + '">' + esc(pill.t) + '</span>' : '';
      var cta = '<button type="button" class="bb-cta" data-act="cta"' + (!ok || busy ? ' disabled' : '') + '>' + (busy ? 'Adding…' : 'Add bundle to cart') + '</button>';
      var dock = $('.bb-dock');
      var oc0 = dock.querySelector('.bb-items'), prevScroll = oc0 ? oc0.scrollLeft : 0;
      dock.classList.toggle('open', open);

      if (!open) {
        var dots = '';
        keys.forEach(function (k) {
          var it = items[k];
          dots += '<span class="bb-th' + (k === fresh && freshNew ? ' new' : '') + '" style="' + esc(it.style) + '" title="' + esc(it.name) + '">' +
            '<img src="' + esc(it.img) + '" alt="' + esc(it.name) + '">' + (it.qty > 1 ? '<em>' + it.qty + '</em>' : '') + '</span>';
        });
        for (var d = 0; d < Math.max(0, MIN - n); d++) dots += '<i class="e"></i>';
        dock.innerHTML =
          '<div class="bb-d-main">' +
            '<button type="button" class="bb-chev" data-act="toggle" aria-label="Show your box" aria-expanded="false">' + CHEV + '</button>' +
            '<div class="bb-d-title"><b>Your box</b> &middot; ' + n + ' ' + unit(n) + '</div>' +
            '<div class="bb-dots">' + dots + '</div>' + pillHTML +
            '<span class="bb-d-sep"></span>' +
            (disc ? '<div class="bb-d-save">You save <span data-cu="save">' + money(disc) + '</span></div>' : '') +
            '<div class="bb-d-tot">Total <b data-cu="total">' + money(total) + '</b></div>' +
            cta +
          '</div>' +
          '<div class="bb-rail-wrap">' + railHTML(n, pct, bubble) + '</div>';
      } else {
        var cardsHTML = keys.map(function (k) {
          var it = items[k];
          return '<div class="bb-it' + (k === fresh && freshNew ? ' new' : '') + '" data-id="' + k + '" style="' + esc(it.style) + '">' +
            '<button type="button" class="x" data-act="rm" data-id="' + k + '" aria-label="Remove ' + esc(it.name) + '">&#10005;</button>' +
            '<div class="im"><img src="' + esc(it.img) + '" alt=""><span class="bb-ov"><b>' + esc(it.name) + '</b><small>' + esc(it.spec) + '</small></span></div>' +
            '<div class="t">' + esc(it.name) + '</div><div class="s">' + esc(it.spec) + '</div>' +
            '<div class="bb-step"><button type="button" data-act="dec" data-id="' + k + '" aria-label="Remove one">&minus;</button><span>' + it.qty + '</span><button type="button" data-act="inc" data-id="' + k + '" aria-label="Add one"' + (n + STEP > MAX ? ' disabled' : '') + '>+</button></div>' +
          '</div>';
        }).join('');
        for (var e = 0; e < Math.max(0, MIN - n); e++) cardsHTML += '<div class="bb-it e" aria-hidden="true">' + SPOOL + '</div>';

        var openMsg;
        if (evt) openMsg = bubble;
        else if (n < MIN || !ok) openMsg = '<div class="bb-bub plain" role="status">' + esc(msg) + '</div>';
        else if (nx) openMsg = '<div class="bb-bub plain" role="status"><b>' + off + '% off unlocked</b> · Add ' + (nx.n - n) + ' more ' + unit(nx.n - n) + ' for ' + nx.off + '% off</div>';
        else openMsg = '<div class="bb-bub plain" role="status"><b>Top tier unlocked</b> · ' + off + '% off</div>';

        dock.innerHTML =
          '<div class="bb-d-top">' +
            '<button type="button" class="bb-chev" data-act="toggle" aria-label="Hide your box" aria-expanded="true">' + CHEV + '</button>' +
            '<div class="bb-d-hd"><h2>Your box</h2><div><span>' + n + ' ' + unit(n) + ' selected</span>' + pillHTML +
              (n ? '<button type="button" class="bb-clear" data-act="clear">' + TRASH + ' Clear</button>' : '') + '</div></div>' +
            '<div class="bb-rail-wrap">' + railHTML(n, pct, openMsg, true) + '</div>' +
          '</div>' +
          '<div class="bb-car">' +
            '<button type="button" class="bb-arr l" data-act="car-l" aria-label="Previous" hidden>' + ARR_L + '</button>' +
            '<div class="bb-items">' + cardsHTML + '</div>' +
            '<button type="button" class="bb-arr r" data-act="car-r" aria-label="Next" hidden>' + ARR_R + '</button>' +
          '</div>' +
          '<div class="bb-d-foot">' +
            '<div class="k">Subtotal<b>' + money(sub) + '</b></div><span class="sp"></span>' +
            '<div class="k sv">Bundle savings<b data-cu="save" data-neg="1">' + (disc ? '−' : '') + money(disc) + '</b></div><span class="sp"></span>' +
            '<div class="k big">Total<b data-cu="total">' + money(total) + '</b></div>' +
            '<div class="go">' + cta + '<div class="bb-note">Bundle discount applies to displayed prices.</div></div>' +
          '</div>';

        // keep carousel position; bring a newly added card into view
        var c = dock.querySelector('.bb-items');
        if (c) {
          c.scrollLeft = prevScroll;
          var fc = fresh ? c.querySelector('.bb-it[data-id="' + fresh + '"]') : null;
          if (fc) {
            var L = fc.offsetLeft, R = L + fc.offsetWidth;
            if (L < c.scrollLeft) c.scrollLeft = L - 4;
            else if (R > c.scrollLeft + c.clientWidth) c.scrollLeft = R - c.clientWidth + 4;
          }
        }
      }
      updArrows();

      // smooth fill + count-up
      Array.prototype.forEach.call(dock.querySelectorAll('[data-to]'), function (el) {
        void el.offsetWidth;
        if (el.classList.contains('bb-fill')) el.style.width = el.dataset.to + '%'; else el.style.left = el.dataset.to + '%';
      });
      Array.prototype.forEach.call(dock.querySelectorAll('[data-cu]'), function (el) {
        var isSave = el.dataset.cu === 'save', neg = !!el.dataset.neg;
        tween(el, isSave ? lastDisc : lastTotal, isSave ? disc : total, function (v) {
          v = Math.round(v);
          return (neg && v > 0 ? '−' : '') + money(v);
        });
      });
      lastPct = pct; lastDisc = disc; lastTotal = total; fresh = null; freshNew = false;
    }

    function render() { syncCards(); renderDock(); }
    if (MOB.addEventListener) MOB.addEventListener('change', function () { lastPct = railPos(count()); renderDock(); });

    function change(id, d) {
      if (!items[id]) return;
      if (d > 0 && overCap(d)) return;
      var before = items[id].qty;
      items[id].qty += d;
      var after = Math.max(0, items[id].qty);
      if (items[id].qty <= 0) delete items[id];
      bump(after - before);
      if (d > 0) fresh = id;
      render();
    }

    /* ---------- events ---------- */
    root.addEventListener('input', function (e) {
      if (e.target.classList.contains('bb-q-in')) { filt.q = e.target.value; applyFilters(); }
    });

    root.addEventListener('change', function (e) {
      var el = e.target;
      if (el.classList.contains('bb-stock')) { filt.stock = el.checked; applyFilters(); return; }
      if (el.classList.contains('bb-var')) {
        var c = el.closest('.bb-card'), o = el.selectedOptions[0];
        c.querySelector('.bb-now').textContent = money(+o.dataset.price);
        var was = c.querySelector('.bb-was');
        was.hidden = !(+o.dataset.compare > +o.dataset.price);
        was.textContent = money(+o.dataset.compare);
        syncCards();
      }
    });

    root.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b || !root.contains(b)) return;

      // filters
      if (b.classList.contains('bb-chip')) { filt.cat = b.dataset.cat; drawCats(); applyFilters(); return; }
      if (b.classList.contains('bb-dot')) { filt.fam = filt.fam === b.dataset.fam ? 'all' : b.dataset.fam; drawSwatches(); applyFilters(); return; }
      if (b.classList.contains('bb-more')) { filt.expanded = !filt.expanded; drawSwatches(); return; }

      // product card
      var card = b.closest('.bb-card');
      if (card) {
        var sel = card.querySelector('.bb-var'), o = sel.selectedOptions[0], id = sel.value;
        if (b.classList.contains('bb-add')) {
          if (overCap(STEP)) return;
          var wasNew = !items[id];
          if (!items[id]) {
            items[id] = {
              id: id, pid: card.dataset.pid,
              name: card.dataset.title + (o.dataset.vt ? ' – ' + o.dataset.vt : ''),
              spec: card.dataset.spec, img: card.dataset.img, price: +o.dataset.price, qty: 0,
              hex: card.dataset.hex, style: card.getAttribute('style') || ''
            };
          }
          items[id].qty += STEP;
          bump(STEP); fresh = id; freshNew = wasNew;
          render();
        } else if (b.classList.contains('bb-cp')) change(id, STEP);
        else if (b.classList.contains('bb-cm')) change(id, -STEP);
        return;
      }

      // dock
      var act = b.dataset.act;
      if (act === 'toggle') { open = !open; renderDock(); }
      else if (act === 'inc') change(b.dataset.id, STEP);
      else if (act === 'dec') change(b.dataset.id, -STEP);
      else if (act === 'dec1') change(b.dataset.id, -1);
      else if (act === 'car-l' || act === 'car-r') {
        var cc = $('.bb-items');
        if (cc) cc.scrollBy({ left: (act === 'car-l' ? -1 : 1) * cc.clientWidth * 0.8, behavior: 'smooth' });
      }
      else if (act === 'rm') { bump(-items[b.dataset.id].qty); delete items[b.dataset.id]; render(); }
      else if (act === 'clear') { bump(-count()); items = {}; render(); }
      else if (act === 'cta') addToCart();
    });

    function addToCart() {
      if (busy) return;
      if (!validSize(count())) { toast('Boxes come in ' + SIZES_TXT + ' ' + UN + '.', true); return; }
      busy = true; renderDock();
      var root_ = (window.Shopify && Shopify.routes) ? Shopify.routes.root : '/';
      // Visible "Bundle" property lets the cart group lines under e.g. "Box of 7"
      var boxN = count(), boxName = 'Box of ' + boxN;
      var bundleId = 'bb-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
      var payload = {
        items: Object.keys(items).map(function (k) {
          return { id: +k, quantity: items[k].qty, properties: { 'Bundle': boxName, '_bundle': 'build-your-box', '_bundle_id': bundleId, '_bundle_size': String(boxN) } };
        })
      };
      // ask Shopify for the cart drawer's HTML in the same request, so the drawer can open straight away
      var drawer = document.querySelector('cart-drawer');
      var hasDrawer = !!(drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function');
      if (hasDrawer) {
        payload.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        payload.sections_url = window.location.pathname;
      }
      fetch(root_ + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error(j.description || 'Could not add to cart');
            return j;
          });
        })
        .then(function (data) {
          // reset so the builder is usable again (also if the page is restored via Back)
          items = {}; busy = false; open = false; render();
          if (hasDrawer && data && data.sections) {
            try {
  drawer.classList.remove('is-empty');
  var di = drawer.querySelector('cart-drawer-items');
  if (di) di.classList.remove('is-empty');
  drawer.renderContents(data);
  setTimeout(function () {
    drawer.classList.remove('is-empty');
    var d2 = drawer.querySelector('cart-drawer-items');
    if (d2) d2.classList.remove('is-empty');
  }, 50);
  return;
} catch (e) { /* fall through to the cart page */ }
          }
          toast('Bundle added to cart');
          setTimeout(function () { window.location.href = root_ + 'cart'; }, 600);
        })
        .catch(function (err) {
          toast(err && err.message ? err.message : 'Could not add to cart', true);
          busy = false; renderDock();
        });
    }
    window.addEventListener('pageshow', function (e) { if (e.persisted) { busy = false; items = {}; render(); } });

    applyFilters();
    render();
  }

  function boot() { document.querySelectorAll('.bb').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('.drawer-content-wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();
})();
